export class FormatUtil {

    public static removeSpecialCharacters(sentence: string): string {
        return sentence.replace(/[^\d]+/g, '');
    }

    /**
     * Remove tudo que nao for alfanumerico e converte para maiusculas.
     * Usado para CPF/CNPJ, ja que o CNPJ pode conter letras (A-Z) a partir de 2026.
     */
    public static removeNonAlphanumeric(sentence: string): string {
        if (sentence == null) {
            return '';
        }
        return sentence.replace(/[^a-zA-Z0-9]+/g, '').toUpperCase();
    }
    
    public static replaceSpecialCharacters(sentence: string): string {
        return sentence.replace(/[^a-zA-Z0-9]+/g, ' ');
    }

    public static hourFromTime(hour: string): string {
        return hour.substring(0, 2);
    }

    public static minutesFromTime(hour: string): string {
        return hour.substring(3, 5);
    }

    public static formatHourOrMinute(value: number): string | number {
        return value > 9 ? value : '0' + value;
    }

    public static getNotAccents(value): string {
        if (value == null){
          return '';
        }
        let newValue = value;
        const mapAccentsHex = {
            a: /[\xE0-\xE6]/g,
            A: /[\xC0-\xC6]/g,
            e: /[\xE8-\xEB]/g,
            E: /[\xC8-\xCB]/g,
            i: /[\xEC-\xEF]/g,
            I: /[\xCC-\xCF]/g,
            o: /[\xF2-\xF6]/g,
            O: /[\xD2-\xD6]/g,
            u: /[\xF9-\xFC]/g,
            U: /[\xD9-\xDC]/g,
            c: /\xE7/g,
            C: /\xC7/g,
            n: /\xF1/g,
            N: /\xD1/g,
        };

        // tslint:disable-next-line: forin
        for (const letter in mapAccentsHex) {
            const regularExpression = mapAccentsHex[letter];
            newValue = newValue.replace(regularExpression, letter);
        }

        return newValue;
    }

    public static verifyIfStringContainsSubStringWithoutAccents(field: string, substring: string): boolean {
      return FormatUtil.getNotAccents(field).toUpperCase().includes(FormatUtil.getNotAccents(substring).toUpperCase())
    }

    public static verifyIfPhoneStringContainsSubString(field: string, substring: string): boolean {
      return FormatUtil.removeSpecialCharacters(field).toUpperCase().includes(FormatUtil.removeSpecialCharacters(substring).toUpperCase())
    }

    public static groupBy(collection, property): any[] {
        let i = 0;
        let val;
        let index;
        const values = [];
        const result = [];
        for (; i < collection.length; i++) {
            val = collection[i][property];
            index = values.indexOf(val);
            if (index > -1) {
                result[index].push(collection[i]);
            }
            else {
                values.push(val);
                result.push([collection[i]]);
            }
        }
        return result;
    }

    public static groupByReduce(xs, key): any[] {
        return xs.reduce((rv, x) => {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    }

    public static roundTwoDecimal(value: number): number {
        return Math.round(value*100) / 100;
    }

    public static formatCPF(CPF) {
      let federalIdMask = CPF;
      federalIdMask = federalIdMask.replace( /(\d{3})(\d)/ , "$1.$2");
      federalIdMask = federalIdMask.replace( /(\d{3})(\d)/ , "$1.$2");
      //de novo (para o segundo bloco de números)
      federalIdMask = federalIdMask.replace( /(\d{3})(\d{1,2})$/ , "$1-$2");

      return federalIdMask;
    }

    public static formatCNPJ(CNPJ) {
      if (CNPJ == null) {
        return CNPJ;
      }

      // CNPJ pode ser alfanumerico (12 primeiras posicoes A-Z/0-9, 2 ultimas numericas).
      // Normaliza removendo mascara/caracteres invalidos e aplica XX.XXX.XXX/XXXX-XX por posicao.
      const clean = CNPJ.toString().replace(/[^a-zA-Z0-9]/g, '').toUpperCase();

      if (clean.length <= 2) { return clean; }
      if (clean.length <= 5) { return clean.replace(/^(\w{2})(\w+)/, '$1.$2'); }
      if (clean.length <= 8) { return clean.replace(/^(\w{2})(\w{3})(\w+)/, '$1.$2.$3'); }
      if (clean.length <= 12) { return clean.replace(/^(\w{2})(\w{3})(\w{3})(\w+)/, '$1.$2.$3/$4'); }

      return clean.replace(/^(\w{2})(\w{3})(\w{3})(\w{4})(\w{1,2}).*/, '$1.$2.$3/$4-$5');
    }

    public static firstLetterUppercase(text: string): string{
      return text.charAt(0).toUpperCase() + text.slice(1);
    }

    /**
     * Completa o valor com zeros a esquerda ate o tamanho informado.
     * Valores nulos/vazios viram string vazia e valores nao numericos
     * sao mantidos como estao (ex.: matricula com letras).
     */
    public static padLeftZeros(value: any, length: number): string {
      if (value === null || value === undefined) {
        return '';
      }
      const text = value.toString().trim();
      if (text === '' || !/^\d+$/.test(text)) {
        return text;
      }
      return text.padStart(length, '0');
    }

}
